import { getPost, getPosts } from '$lib/content';
import { error } from '@sveltejs/kit';

export const prerender = true;

export function entries() {
	return getPosts().map((post) => ({ slug: post.slug }));
}

export function load({ params }) {
	if (!params.slug) {
		throw error(404, 'Post not found');
	}

	return {
		post: getPost(params.slug)
	};
}
